"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
const style = {
  direccionInput: {
    margin: '16px 8px 8px 8px'
  },
  skeleton: {
    margin: 'auto',
    width: '100%',
    'background-image': 'linear-gradient( 100deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.5) 50%, rgba(255, 255, 255, 0) 80% ),\
        linear-gradient( lightgray 20px, transparent 0 )',
    backgroundRepeat: 'repeat-y',
    backgroundSize: '50px 200px,100% 1px',
    backgroundPosition: '0 0, 0px 100%',
    animation: '$shine 1s infinite'
  },
  '@keyframes shine': {
    'to': {
      backgroundPosition: '100% 0, 100% 100%'
    }
  }
};
var _default = style;
exports.default = _default;